var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : _vm.tag,{tag:"component",staticClass:"czCard",class:{ 'czCard--padded': _vm.padded, 'czCard--link': !!_vm.to, 'czCard--flat': _vm.flat },attrs:{"to":_vm.to || undefined}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }